import type { UseQueryResult } from '@tanstack/react-query'
import * as React from 'react'

export function useOnSuccess<TData>(
	query: UseQueryResult<TData>,
	callback: (data: TData) => void,
) {
	const callbackRef = React.useRef(callback)

	React.useEffect(() => {
		callbackRef.current = callback
	}, [callback])

	React.useEffect(() => {
		if (query.status === 'success') {
			callbackRef.current?.(query.data)
		}
	}, [query.data, query.status])
}
